import styled from 'styled-components';
export const S = {
    Button: styled.button `
    display: flex;
    align-items: center;
    justify-content: center;
    width: 41px;
    height: 41px;
    background: ${(props) => props.color};
    border: none;
    border-radius: 50%;

    opacity: ${(props) => (props.disabled ? 0.5 : 1)};
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};

    &:active {
      box-shadow: 0 4px 12px rgb(51 51 51 / 25%);
    }
  `,
};
